/** Copyright © 2013-2022 DataYes, All Rights Reserved. */

import styled from 'styled-components';

export const StyledMenu = styled.nav`
  position: fixed;
  height: calc(100vh - 66px);
  overflow: auto;
  width: 166px;
  font-size: 14px;
  box-shadow: 0 2px 8px 0 rgba(182, 186, 189, 0.3);
  padding: 10px 0 60px 0;
  margin-left: -176px;
  background-color: #fff;

  ::-webkit-scrollbar {
    display: none;
  }

  .ant-menu.ant-menu-inline {
    color: #333;
    user-select: none;
    background-color: #fff;

    // root set
    &.ant-menu-root {
      border: none;

      > .ant-menu-submenu {
        margin-bottom: 10px;

        &.ant-menu-submenu-selected {
          color: #333;
        }

        > .ant-menu-submenu-title {
          font-weight: bold;
        }
      }
    }

    > .ant-menu-item::after {
      right: initial;
      left: 0;
    }

    > .ant-menu-item,
    > .ant-menu-submenu > .ant-menu-submenu-title {
      height: 30px;
      line-height: 30px;
      margin: 0;

      &:hover {
        background: #f1f8ff;
        color: #3093db;
      }
    }
  }
`;
